import { useEffect, useState } from "react";

export const useGiftData = () => {
  const [popularGifts, setPopularGifts] = useState<string[]>([]);
  const [suggestions, setSuggestions] = useState<any[]>([]);

  useEffect(() => {
    fetchGiftData();
  }, []);

  const fetchGiftData = async () => {
    try {
      const [popularRes, suggestRes] = await Promise.all([
        fetch("/gifts/popular-products"),
        fetch("/gifts/suggest"),
      ]);

      const popular = await popularRes.json();
      const suggest = await suggestRes.json();

      const popularIds = popular.data?.map((item: any) => item.productId) || [];
      setPopularGifts(popularIds);
      setSuggestions(suggest.data || []);
    } catch (error) {
      console.error("Failed to fetch gift data:", error);
    }
  };

  return { popularGifts, suggestions };
};
